<template>
  <CustomModal @close="$emit('close')"
               :closable-on-click-outside="false">
    <template v-slot:body>
      <div class="token-preview-modal">
        <h3 class="text-xl font-bold text-text leading-tight mb-8">{{ $t('previewTitle') }}</h3>
        <p class="text-md font-medium text-text leading-tight mb-8">
          {{ $t('previewText') }}
        </p>
        <div class="flex gap-4 items-center">
          <BaseInput :value="token"
                     class="flex-1"
                     disabled=""/>
          <CopyIcon :value="token" class="flex-none"/>
        </div>
        <BaseButton class="w-full mt-8" theme="red" @click="$emit('close')">
          {{ $t('confirmText') }}
        </BaseButton>
      </div>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import CopyIcon from "@/components/common/CopyIcon";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "ModalPreviewToken",
  components: {BaseButton, CopyIcon, BaseInput, CustomModal},
  props: {
    token: {
      type: String,
      required: true
    }
  },
  i18n: {
    messages: {
      en: {
        ru: {
          previewTitle: 'Token created successfully',
          previewText: 'Copy and use this token🤝',
          confirmText: 'Copied, close window'
        }
      },
      ru: {
        previewTitle: 'Токен успешно создан',
        previewText: 'Скопируйте и используйте данный токен🤝',
        confirmText: 'Скопировал, закрыть окно'
      }
    }
  }
}
</script>

<style scoped>
.token-preview-modal {
  width: 400px;
}
</style>